import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ProductAction } from '@stores/product/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';

interface LotteryRecordSearchPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    product?: ProductAction;
    productList?: any[];
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    navList?: any
    navCurrentIndex?: any
    navCurrentType?: any
    navClick?: Function
}
interface LotteryRecordSearchPCState {
    loading: boolean;
    error: any
    pageLoaded: any
}
@inject('app', 'site', 'user', 'product')
@observer
class LotteryRecordSearchPCPage extends BasePage<LotteryRecordSearchPCPageProps, LotteryRecordSearchPCState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
    };

    componentDidMount() {
        this.props.history.push(`/downloadAppEnter`);
        super.componentDidMount();
    }

    getPreviewUrl = () => {
        const { location } = this.props;
        const params = new URLSearchParams(location.search);
        params.set('previewFrame', '1');

        const queryString = params.toString();
        return `${location.pathname}${queryString ? `?${queryString}` : ''}`;
    };

    render() {
        return (<div className={styles.wrapper}>
            
        </div>)
    }
}

export default withRouter(LotteryRecordSearchPCPage);
